import React, { useState,useRef,useEffect }  from 'react';
import { Popconfirm, message, Button, ConfigProvider,Dropdown,Menu,Popover} from 'antd';
import { FilePdfOutlined } from '@ant-design/icons';
import { ProTable } from '@ant-design/pro-components';
import Viewpdf from './components/viewpdf';
import {api_turbotq_list } from '../../api';
import routes from '../../menuRoute/index';
import { encrypt,decrypt,localStorageSet,localStorageGet,waitTime } from '../../utils/global.js';
// import JSZip from 'jszip';
// import { saveAs } from 'file-saver';
import zhCN from 'antd/lib/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn')

export default () => {
  const actionRef = useRef();

  const [showModal, setShowModal] = useState(false);
  const [rowInfo, setRowInfo] = useState({});
  const [pagination, setPagination] = useState({current:1,pageSize:10,total:0});
  const [pageSize, setPageSize] = useState(10);
  /*** @zh-CN 所有页面列表 *  */
  const [treeMenus, setTreeMenus] = useState([]);
  /*** @zh-CN 已选中列表 *  */

  const currentUserinfo = localStorageGet('UserInfo_k');
  console.log('========order list currentUserinfo==========', currentUserinfo)

  useEffect(() => {
    if (routes) {
      let menus= getTreeNodes(routes);
      console.log(menus);
      setTreeMenus(menus);
    }
  }, []);
  
  const getTreeNodes = (list) => {
    console.log(list)
    let arr = [];
    list.forEach((item)=>{
        // if(item.name && (!item.hideInMenu)){
        if(item.title){
            if(item.children){
              let child=[]
                arr.push({title:item.title,key:item.path,children:getTreeNodes(item.children)})
            }else{
                arr.push({title:item.title,key:item.path})
            }
        }else{
            if(item.children){
                getTreeNodes(item.children)
            }
        }
    });
    return arr
    // if(arr.length !== 0) setTreeData(arr);
 }

 
 const closeModal = () =>{
  setShowModal(false);
}


  let columns = [
    {
      title: '下单邮箱',
      dataIndex: 'owner',
      hideInTable:currentUserinfo.roleid=='2' ? true : false,
      hideInSearch:currentUserinfo.roleid=='2' ? true : false,
      key:"owner",
      width: 200,
      ellipsis: true,
    },
    {
      title: '姓名',
      dataIndex: 'name',
      search:true,
      key:"name",
      width: 100,
      ellipsis: true,
    },
    {
      title: '身份证号',
      dataIndex: 'idcardno',
      search:false,
      key:"idcardno",
      width: 180,
      ellipsis: true,
    },
    {
      title: '学历证书编号',
      dataIndex: 'certificateno',
      search:true,
      key:"certificateno",
      width: 160,
      ellipsis: true,
    },
    {
      title: '学历查询结果',
      dataIndex: 'queryflag',
      search:false,
      key:"queryflag",
      width: 100,
      ellipsis: true,
      render: (_,record) => {
        return record.queryflag=='生成报告' ? 
          <span>{record.queryflag} 
          <FilePdfOutlined style={{marginLeft:5}}
            onClick={()=>{
              setRowInfo({name:record.name, path:record.reportpath,type:"学历"});
              setShowModal(true);
            }} /></span>
          : record.queryflag
      }

    },
    {
      title: '学历查询时间',
      dataIndex: 'querydate',
      search:false,
      key:"querydate",
      width: 150,
      ellipsis: true,
    },
    {
      title: '学位证书编号',
      dataIndex: 'degreeno',
      search:true,
      key:"degreeno",
      width: 160,
      ellipsis: true,
    },
    {
      title: '学位查询结果',
      dataIndex: 'queryflagd',
      search:false,
      key:"queryflagd",
      width: 120,
      ellipsis: true,
      render: (_,record) => {
        return record.queryflagd=='生成报告' ? 
          <span>
            {record.queryflagd} 
            <FilePdfOutlined style={{marginLeft:5}}
              onClick={()=>{
                setRowInfo({name:record.name, path:record.reportpathd,type:"学位"});
                setShowModal(true);
              }} />
          </span>
          : record.queryflagd
      }
    },
    {
      title: '学位查询时间',
      dataIndex: 'querydated',
      search:false,
      key:"querydated",
      width: 150,
      ellipsis: true,
    },
  /*
    {
      title:'创建时间',
      dataIndex: 'creat_time',
      valueType: "dateRange",
      width: 150,
      key:"creat_time",
      order: 4,
      fieldProps: {
        picker: "date",
        format:'YYYY-MM-DD',
        allowClear:true,
        // defaultValue:[moment(startTime), moment(endTime)]
      },
      render: (_,record) => {
        return record.creat_time
      }
    },
    {
      title: '面试官',
      dataIndex: 'interviewer_id',
      // search:false,
      order: 3,
      key:"interviewer_id",
      width: 100,
      ellipsis: true,
      valueType: 'select',
      valueEnum: interviewEnum,
    },
    // {
    //   title: '可用面试时间',
    //   dataIndex: 'avl_intv_time',
    //   search:false,
    //   key:"avl_intv_time",
    //   width: 150,
    //   ellipsis: true,
    //   render: (_,record) => {
    //     if(record.avl_intv_time){
    //       var times = JSON.parse(record.avl_intv_time);
    //       console.log('-------times--------', times)
    //       var showtimes = [];
    //       for(let t of times){
    //         showtimes.push(t[0]+" - "+t[1]);
    //       }
    //       // return showtimes.join("\n");
    //       var text = showtimes.join("\n");

    //       var content = showPopTime(times);
    //       console.log('----------------content-------------', content)
    //       return (
    //         <Popover content={showPopTime(times)} color="rgb(64,64,64)" key="rgb(64,64,64)" >
    //           <span style={{ maxWidth: 130, display: 'inline-block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
    //             {text}
    //           </span>
    //         </Popover>
    //       );
          
    //     }
    //     else
    //       return '-';
    //   }

    // },
    {
      title: '是否授权日历安排',
      dataIndex: 'ai_auto_time',
      search:false,
      key:"ai_auto_time",
      width: 130,
      valueType: 'select',
      valueEnum: {
        "0": {
          text: '否',
          // status: 'Processing',
        },
        "1": {
          text: '是',
          // status: 'Success',
          // disabled: true,
        },
      },
    },
    {
      title: '启动时间',
      dataIndex: 'execute_time',
      search:false,
      ellipsis: true,
      key:"execute_time",
      width: 150,
    },
    {
      title: '工作岗位',
      dataIndex: 'position_id',
      // search:false,
      order:2,
      key:"position_id",
      width: 100,
      ellipsis: true,
      valueType: 'select',
      valueEnum: positionEnum,
    },
    {
      title: '候选人',
      dataIndex: 'candidates',
      key: 'candidates',
      search: false,
      // ellipsis: true,
      width: 80,
      render: (text, record, _, action) => [
        // "13244687914",' ',"柴鑫","\n","18145503713",' ',"ascnv"
        <UnorderedListOutlined 
          onClick={()=>{
            setRowInfo(record);
            setShowCandidate(true);
          }} />
      ]
    },
    {
      // disable: true,
      width: 100,
      title: '工单类别',
      dataIndex: 'stype',
      // search:false,
      order: 5,
      hideInTable: true,
      key:"stype",
      ellipsis: true,
      valueType: 'select',
      valueEnum: orderStatusSearchEnum,
    },
    {
      // disable: true,
      width: 100,
      title: '状态',
      dataIndex: 'status',
      search:false,
      key:"status",
      ellipsis: true,
      valueType: 'select',
      valueEnum: orderStatusEnum,
    },
    {
      // disable: true,
      width: 100,
      title: '面试方式',
      dataIndex: 'interview_method',
      search:false,
      key:"interview_method",
      ellipsis: true,
      valueType: 'select',
      valueEnum: interviewMethodEnum,
    },
    // {
    //   title: '面试地点',
    //   dataIndex: 'interview_location',
    //   search:false,
    //   key:"interview_location",
    //   width: 100,
    //   ellipsis: true,
    // },
    // {
    //   title: '避开午休',
    //   dataIndex: 'avoid_noon',
    //   search:false,
    //   key:"avoid_noon",
    //   width: 130,
    //   valueType: 'select',
    //   valueEnum: {
    //     "0": {
    //       text: '否',
    //       // status: 'Processing',
    //     },
    //     "1": {
    //       text: '是',
    //       // status: 'Success',
    //       // disabled: true,
    //     },
    //   },
    // },
    // {
    //   title: '午休时间',
    //   dataIndex: 'noon_time',
    //   search:false,
    //   key:"noon_time",
    //   width: 100,
    //   ellipsis: true,
    // },
    {
      // disable: true,
      width: 100,
      title: '安排方式',
      dataIndex: 'prior_option',
      search:false,
      key:"prior_option",
      ellipsis: true,
      valueType: 'select',
      valueEnum: priorOptionEnum,
    },
    {
      title: '面试时长',
      dataIndex: 'duration',
      search:false,
      key:"duration",
      width: 100,
      ellipsis: true,
    },
    {
      // disable: true,
      width: 100,
      title: '创建人',
      dataIndex: 'creat_userid',
      // search:false,
      order:1,
      key:"creat_userid",
      ellipsis: true,
      valueType: 'select',
      valueEnum: orderCreatUserEnum,
    },
    {
      // disable: true,
      width: 100,
      title: '后备联络人',
      dataIndex: 'back_userid',
      search:false,
      key:"back_userid",
      ellipsis: true,
      valueType: 'select',
      valueEnum: backUserEnum,
    },
    {
      title: '操作记录',
      dataIndex: 'oplog',
      key: 'oplog',
      search: false,
      // ellipsis: true,
      width: 80,
      render: (text, record, _, action) => [
        // "13244687914",' ',"柴鑫","\n","18145503713",' ',"ascnv"
        <UnorderedListOutlined 
          onClick={()=>{
            setRowInfo(record);
            setShowOplogModal(true);
          }} />
      ]
    },
    */
];
  // if(currentUserinfo.roleid=='2')

   
  return (
    <ConfigProvider locale={zhCN}>
    <div>
          
    <ProTable
      headerTitle="认证列表"
      columns={columns}
      actionRef={actionRef}
      rowKey="id"
      cardBordered
      defaultSize="small"
      request={async (params, sort, filter) => {
        console.log(params,sort, filter);
        // if(!params.creat_time)
        //   params.creat_time = [startTime, endTime];

        // await waitTime(2000);
        var tableData = [];
        var res = await api_turbotq_list(params);
        console.log('api_turbotq_list-res-----------------', res);
        if(res.data.code == 9){
          waitTime(100);
          tableData = res.data.list;
          setPagination({current:parseInt(res.data.pageinfo.current), pageSize:parseInt(res.data.pageinfo.pageSize), total:parseInt(res.data.pageinfo.total)})
        }else
          message.error(res.data.msg);

        return {
          data: tableData,
          // current: res.data.pageNo,
          // pageSize: res.data.pageSize,
          success: true,
          // total: res.data.totalRows,
        };
      }}
      search={{
        labelWidth: 'auto',
      }}
      options={{
        reload: false, // 去掉刷新按钮
        density: false, // 去掉密度按钮
        setting: true, // 保留列设置按钮
        setting: {
          listsHeight: 400,
        },
      }}
      style={{lineHeight: '0.40rem',marginTop:'0.32rem',overflowX: 'scroll',overflowY: 'scroll'}}  
      scroll={{x:1000}}
      columnsState={{
        persistenceKey: 'pro-table-order',
        persistenceType: 'localStorage',
        onChange(value) {
          console.log('value: ', value);
        },
      }}

      // form={{
      //   // 由于配置了 transform，提交的参与与定义的不同这里需要转化一下
      //   syncToUrl: (values, type) => {
      //     if (type === 'get') {
      //       return {
      //         ...values,
      //         created_at: [values.startTime, values.endTime],
      //       };
      //     }
      //     return values;
      //   },
      // }}
      pagination={{
        // pageSizeOptions: [10, 20, 50, 100, pagination.total],
        showSizeChanger: true,
        pageSize: pagination.pageSize,
        current:pagination.current,
        total:pagination.total,
        onChange: (page) => console.log(page),
      }}

      // dateFormatter="string"

      toolBarRender={() => [
        // <Button
        //   key="button"
        //   icon={<PlusOutlined />}
        //   // style={{backgroundColor:"rgb(5,168,137)"}}
        //   onClick={async() => {
        //     setRowInfo({});
        //     await waitTime(100);
        //     setShowModal(true);
        //   }}
        //   type="primary"
        //   disabled={currentUserinfo.roleid=='99'||currentUserinfo.roleid=='1'?true:false}
        //   // style={{display: currentUserinfo.roleid=='2'?"block":"none"}}
        // >
        //   新建工单
        // </Button>,
      ]}
    />

    
    <Viewpdf
      showModal={showModal}
      closeModal={closeModal}
      rowInfo={rowInfo}
    />

    </div>
    </ConfigProvider>
  );
};